import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../ui/LanguageSwitcher';
import { logout } from '../../services/api';

const navItems = [
  { path: '/admin', labelKey: 'navigation.overview' },
  { path: '/admin/homepage', labelKey: 'navigation.homepage' },
  { path: '/admin/contact-info', labelKey: 'navigation.contactInfo' },
  { path: '/admin/translations', labelKey: 'navigation.translations' },
  { path: '/admin/files', labelKey: 'navigation.files' },
  { path: '/admin/projects', labelKey: 'navigation.projects' },
  { path: '/admin/articles', labelKey: 'navigation.articles' },
  { path: '/admin/jobs', labelKey: 'navigation.jobs' },
  { path: '/admin/applications', labelKey: 'navigation.applications' },
  { path: '/admin/contacts', labelKey: 'navigation.contacts' },
  { path: '/admin/analytics', labelKey: 'navigation.analytics' },
  { path: '/admin/settings', labelKey: 'navigation.settings' },
];

const AdminDashboardLayout = () => {
  const { t } = useTranslation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const updateViewport = () => setIsMobile(window.innerWidth < 900);
    updateViewport();
    window.addEventListener('resize', updateViewport);
    return () => window.removeEventListener('resize', updateViewport);
  }, []);

  useEffect(() => {
    if (isMobile) {
      setSidebarOpen(false);
    }
  }, [location.pathname, isMobile]);

  const toggleSidebar = () => setSidebarOpen((current) => !current);
  const handleSignOut = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className={`admin-shell ${sidebarOpen ? 'sidebar-open' : ''}`}>
      <button type="button" className="admin-sidebar-toggle" aria-label={t('layout.toggleNavigation')} onClick={toggleSidebar}>
        ☰
      </button>

      <aside className={`admin-sidebar ${sidebarOpen ? 'open' : ''}`} aria-label={t('layout.adminNavigation')}>
        <div>
          <h1 className="brand-title">{t('layout.siteTitle')}</h1>
          <p className="brand-subtitle">{t('layout.adminDashboard')}</p>
        </div>
        <nav className="admin-nav" aria-label={t('layout.adminSectionNavigation')}>
          {navItems.map((item) => (
            <NavLink key={item.path} to={item.path} className={({ isActive }) => `admin-nav-link${isActive ? ' active' : ''}`}>
              {t(item.labelKey)}
            </NavLink>
          ))}
        </nav>
      </aside>

      {isMobile && sidebarOpen && <div className="sidebar-overlay" onClick={toggleSidebar} aria-hidden="true" />}

      <main className="admin-main">
        <header className="admin-header">
          <div>
            <h2>{t('layout.adminWorkspace')}</h2>
            <p style={{ margin: 0, color: 'var(--color-muted)' }}>{t('layout.manageDescription')}</p>
          </div>
          <div className="header-actions">
            <LanguageSwitcher />
            <button type="button" className="btn btn-secondary" onClick={handleSignOut}>
              {t('layout.signOut')}
            </button>
          </div>
        </header>

        <section className="admin-page-card">
          <Outlet />
        </section>
      </main>
    </div>
  );
};

export default AdminDashboardLayout;
